import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import 'bulma/css/bulma.css';
import HomePage from './homepage.js';
import PricingPage from './pricing.js';
import ExclamationPage from './exclamation.js';

const App = () =>
  <Router>
    <div className="app">
      <Route exact path="/" component={() => <HomePage />} />
      <Route exact path="/pricing" component={() => <PricingPage />} />
      <Route exact path="/exclamation" component={() => <ExclamationPage />} />
    </div>
  </Router>

export default App;



// WEBPACK FOOTER //
// ./src/App.js